module.exports = __webpack_public_path__ + "static/img/12Credit-Assessment.19fc9616.gif";